<span class="player-stats-text">{{ playerStatsData.statsText }}</span>
@if (!isEpcotEnabled) {
    <div class="player-stats-value-container">
        <span class="player-stats-value" [msValueSlider]="playerStatsData.statsValue.toString()"></span>
    </div>
} @else {
    <div class="player-stats-value-container" [ngClass]="statsIndicator">
        <span class="player-stats-value">{{ playerStatsData.statsValue }}</span>
    </div>
}
